<template>
  <div
    v-if="$variable('store.showMarket') && $variable('store.marketDisplayName').length > 0"
    class="multi-store-form"
  >
    <div class="multi-store-form__flag-wrapper">
      <responsive-image
        class="multi-store-form__image"
        :alt="currentMarketDisplay"
        :image="{ src: flagSrc }"
        :ratio="false"
      />

      <a
        class="multi-store-form__edit-icon"
        href="/account"
      >
        <span class="visually-hidden">
          {{ $string('general.site_header.market_prompt') }}
        </span>
        <icon-edit />
      </a>
    </div>

    <div class="multi-store-form__display">
      <span class="multi-store-form__name">
        {{ currentMarketDisplay }}
      </span>

      <a
        class="multi-store-form__prompt"
        href="/account"
        v-text="$string('general.site_header.market_prompt')"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Multi store form (multi-store-form)
 * -----------------------------------------------------------------------------
 * Market display with static text and account link prompt.
 * Displays the current market based on Shopify's localization.
 * Users change their location via their account/profile page.
 *
 */
import ResponsiveImage from '~global/images/responsive-image.vue'
import IconEdit from '~icons/general/edit.svg'

export default {
  name: 'MultiStoreForm',

  components: {
    ResponsiveImage,
    IconEdit,
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  computed: {

    /**
     * Compute current market entry from display map.
     * Falls back to GB or first entry if no match found.
     * @returns {Object|null}
     */
    currentMarket() {
      const countryDisplayMap = this.$variable('store.marketDisplayName') || []

      if (!Array.isArray(countryDisplayMap) || countryDisplayMap.length === 0) {
        return null
      }

      const currentCountry = this.$variable('store.country')
      const match = countryDisplayMap.find(
        (entry) => entry.iso_code === currentCountry,
      )

      const fallback = countryDisplayMap.find(
        (entry) => entry.iso_code === 'GB',
      ) || countryDisplayMap[0]

      return match || fallback
    },

    /**
     * Compute current market display name.
     * @returns {String}
     */
    currentMarketDisplay() {
      return this.currentMarket?.market_name || ''
    },

    /**
     * Compute flag image source URL.
     * @returns {String}
     */
    flagSrc() {
      return this.currentMarket?.flag
    },
  },
}
</script>

<style lang="scss">
@import './multi-store-form';
</style>
